var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchspring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1400 1400",
    style: {
      enableBackground: "new 0 0 1400 1400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 454.006,
    y1: 896.86,
    x2: 1005.2311,
    y2: 896.86,
    gradientTransform: "matrix(1 0 0 -1 0 1400)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3A23AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C3CE2"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M574.2,427.7c0,0.1,0.1,0.1,0.1,0.2c-2.2,1-4.4,1.9-6.6,2.9C457.6,484,421.2,636.5,486.3,771.3 L885,578.6c0-0.1-0.1-0.1-0.1-0.2c2.2-1,4.4-1.9,6.6-2.9c110.1-53.2,146.5-205.6,81.4-340.5L574.2,427.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.769,
    y1: 503.14,
    x2: 945.9911,
    y2: 503.14,
    gradientTransform: "matrix(1 0 0 -1 0 1400)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3A23AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4C3CE2"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M515,821.4c0,0.1,0.1,0.1,0.1,0.2c-2.2,1-4.4,1.9-6.6,2.9c-110.1,53.2-146.5,205.6-81.4,340.5 l398.7-192.7c0-0.1-0.1-0.1-0.1-0.2c2.2-1,4.4-1.9,6.6-2.9c110.1-53.2,146.5-205.6,81.4-340.5L515,821.4z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchspring);
export default __webpack_public_path__ + "static/media/searchspring.abe7d3d53954b803dc83ea58fe74a305.svg";
export { ForwardRef as ReactComponent };